export default __webpack_public_path__ + "static/media/none@2x.30ad6979.svg";